import { render } from "./App.vue?vue&type=template&id=628decb8"
const script = {}

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__